import React, { useCallback, useEffect, useMemo, useState } from "react";
import PageHeader from "../components/common/PageHeader";
import useStore from "../store/useStore";
import api from "../services/api";

const Notifications = () => {
  const { toast } = useStore();
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const fetchNotifications = useCallback(async () => {
    try {
      setLoading(true);
      const res = await api.get("/notifications");
      setNotifications(res.data?.data || []);
    } catch (error) {
      console.error("Fetch notifications error:", error);
      toast(error.response?.data?.message || "Failed to load notifications", "error");
    } finally {
      setLoading(false);
    }
  }, [toast]);

  useEffect(() => {
    fetchNotifications();
  }, [fetchNotifications]);

  const unreadCount = useMemo(
    () => notifications.filter((item) => Number(item.isRead) === 0).length,
    [notifications]
  );

  const markAsRead = async (id) => {
    try {
      await api.put(`/notifications/${id}/read`);
      setNotifications((prev) => prev.map((item) => (item.id === id ? { ...item, isRead: 1 } : item)));
    } catch (error) {
      console.error("Mark notification error:", error);
      toast(error.response?.data?.message || "Failed to mark notification as read", "error");
    }
  };

  return (
    <div className="space-y-6">
      <PageHeader
        title="Notifications"
        action={<span className="text-sm font-semibold text-teal-700 bg-teal-50 px-3 py-1.5 rounded-full">Unread: {unreadCount}</span>}
      />

      <section className="rounded-2xl border border-gray-200 bg-white shadow-sm overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-200 bg-gray-50 flex items-center justify-between">
          <h3 className="text-lg font-bold text-gray-900">Notification Center</h3>
          <button onClick={fetchNotifications} className="text-sm font-semibold text-teal-700 hover:text-teal-800">Refresh</button>
        </div>

        <div className="divide-y divide-gray-100">
          {loading ? (
            <div className="p-6 text-sm text-gray-500">Loading notifications...</div>
          ) : notifications.length === 0 ? (
            <div className="p-6 text-sm text-gray-500">No notifications yet.</div>
          ) : notifications.map((item) => (
            <button
              key={item.id}
              onClick={() => markAsRead(item.id)}
              className={`w-full text-left p-6 hover:bg-teal-50 transition-colors ${Number(item.isRead) === 0 ? 'bg-teal-50/50' : 'bg-white'}`}
            >
              <div className="flex items-start justify-between gap-4">
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <h4 className="font-semibold text-gray-900">{item.title}</h4>
                    {!item.isRead && <span className="text-[10px] px-2 py-0.5 rounded-full bg-red-100 text-red-700 font-bold">New</span>}
                  </div>
                  <p className="text-sm text-gray-600">{item.message}</p>
                  <p className="text-xs text-gray-500 mt-2">From {item.senderName || 'System'} • {item.audience}</p>
                </div>
                <span className="text-xs text-gray-500 whitespace-nowrap">{new Date(item.createdAt).toLocaleString()}</span>
              </div>
            </button>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Notifications;
